// Định dạng ô danh sách Job, theo script board Mint-Job (PORT · CARN · HR · etdS · cyOf).
import { findCarrier, findPort } from '@hana/domain';
import type { Job } from './types';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Bảng cảng của script board Mint-Job (PORT); cảng ngoài bảng (vd USLAX của bản ghi vàng) hiện mã. */
const BOARD_PORTS: Record<string, [string, string]> = {
  VNSGN: ['HOCHIMINH CITY', 'VN'], VNVUT: ['VUNG TAU', 'VN'], VNLAN: ['LONG AN', 'VN'], VNVCA: ['CAI MEP', 'VN'],
  KRPUS: ['BUSAN', 'KR'], KRINC: ['INCHEON', 'KR'], KRKAN: ['KWANGYANG', 'KR'], CNNSA: ['NANSHA', 'CN'], CNNGB: ['NINGBO', 'CN'],
  CNQZH: ['QINZHOU', 'CN'], JPTYO: ['TOKYO', 'JP'], JPUKB: ['KOBE', 'JP'], LYMRA: ['MISURATA', 'LY'], MUPLU: ['PORT LOUIS', 'MU'],
  SAJED: ['JEDDAH', 'SA'], PGAMF: ['AMBUNTI', 'PG'], AUSYD: ['SYDNEY', 'AU'], HKHKG: ['HONG KONG', 'HK'], FRFOS: ['FOS-SUR-MER', 'FR'],
  PHMNN: ['MANILA', 'PH'], ITGOA: ['GENOA', 'IT'], USNYC: ['NEW YORK', 'US'], USNWK: ['NEWARK - CA', 'US'], SGSIN: ['SINGAPORE', 'SG'],
  GBSOU: ['SOUTHAMPTON', 'GB'], BEANR: ['ANTWERPEN', 'BE'],
};

/** "HOCHIMINH CITY, VN"; cảng ngoài bảng board thì tra danh mục, chưa có nữa thì giữ mã. */
export function portLabel(code: string): string {
  const b = BOARD_PORTS[code];
  if (b) return `${b[0]}, ${b[1]}`;
  if (code === 'USLAX') return code;
  const p = findPort(code);
  return p ? `${p.name}, ${p.country}` : code;
}

/** Tên hãng hiển thị theo LOGI (MAERSK, ONE-LINE…); không nhận ra thì giữ mã. */
export function carrierName(code: string | null): string {
  if (!code) return '';
  const c = findCarrier(code);
  return c ? (c.logiName ?? c.name) : code;
}

/** `YYYY-MM-DD` → "24-Oct". Chuỗi không đọc được trả `null`. */
export function dayLabel(date: string | null): string | null {
  const m = /^\d{4}-(\d{2})-(\d{2})$/.exec(date ?? '');
  const mon = m ? MONTHS[Number(m[1]) - 1] : undefined;
  return m && mon ? `${m[2]}-${mon}` : null;
}

/** Closing CY dạng "23-Oct 23:59", đọc thẳng từ chuỗi ISO giờ VN (+07:00), không qua múi giờ máy. */
export function cutoffLabel(iso: string | null): string | null {
  const m = /^\d{4}-(\d{2})-(\d{2})T(\d{2}:\d{2})/.exec(iso ?? '');
  const mon = m ? MONTHS[Number(m[1]) - 1] : undefined;
  return m && mon ? `${m[2]}-${mon} ${m[3]}` : null;
}

/** "còn 5h" · "còn 3 ngày" · "đã qua cut-off" (còn lại `null`). */
export function hoursLeftLabel(hours: number | null): string | null {
  if (hours === null) return null;
  if (hours < 0) return 'đã qua cut-off';
  return hours < 24 ? `còn ${Math.round(hours)}h` : `còn ${Math.round(hours / 24)} ngày`;
}

/** Hai ký tự đầu tên sale cho avatar nhỏ. */
export function initials(name: string): string {
  return (name.replace(/[^A-Za-z]/g, '').slice(0, 2) || '?').toUpperCase();
}

export const DIR_LABEL: Record<Job['dir'], string> = { OB: 'Xuất', LS: 'Dịch vụ lẻ', TR: 'Nội địa' };
